import { Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
  imports: [IconComponent],
})
export class IconButtonComponent {
  readonly icon = input<string>();
  readonly text = input<string>();
}
